module.exports = __webpack_public_path__ + "static/media/logoloader2.90116023.gif";